import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "../../../BaseMixer";
import Loader from "@/components/widgets/loader.vue";
import ClientEmailBodyTemplate from "./ClientEmailBodyTemplate.vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Swal from "sweetalert2";
let ClientEmailTemplate = /** @class */ (() => {
    let ClientEmailTemplate = class ClientEmailTemplate extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.assignments = [];
            this.clientContactCustomizedContent = [];
            this.isLoading = false;
        }
        showModal() {
            this.$bvModal.show("client-email-template");
        }
        closeModal() {
            this.clientManagersLists.forEach((c) => (c.isDeFaultTemplateChanged = false));
            this.$bvModal.hide("client-email-template");
            this.clientContactCustomizedContent = [];
        }
        stopLoading() {
            this.isLoading = false;
        }
        close() {
            this.isLoading = false;
            this.closeModal();
        }
        saveClientAssignments() {
            if (this.clientManagersLists.some((x) => !x.isDeFaultTemplateChanged)) {
                var subject = this.clientManagersLists.every((x) => !x.isDeFaultTemplateChanged)
                    ? "Are you sure you want to send it with the default message? Click 'Yes' to send or 'No' to edit the email message."
                    : "You have another Client Manager's email in the next tab. Are you sure you want to send it with the default message? Click 'Yes' to send or 'No' to edit the email message.";
                Swal.fire({
                    customClass: {
                        container: "remove-swal2-container",
                        title: "remove-swal2-title",
                        popup: "remove-swal2-popup",
                        icon: "remove-swal2-icon",
                    },
                    title: "Confirmation",
                    text: subject,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f46a6a",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                }).then((result) => {
                    if (result.value) {
                        return this.saveClientAssignment();
                    }
                    return "";
                });
            }
            else {
                this.saveClientAssignment();
            }
        }
        saveClientAssignment() {
            this.isLoading = true;
            this.clientContactCustomizedContent = this.clientManagersLists.map((item) => {
                return {
                    clientContactId: item.clientContactId,
                    templateContent: item.templateContent,
                };
            });
            this.$emit("save-client-assignments", this.clientContactCustomizedContent);
        }
        get clientManagersLists() {
            if (this.assignments.length > 0) {
                const clientContacts = PAReviewModule.clientInteractionDetails?.clientContacts;
                const employees = PAReviewModule.clientInteractionDetails?.reviews;
                if (this.assignments.length == 0) {
                    return [];
                }
                // Group assignments by clientContactId
                const groupedAssignments = {};
                this.assignments.forEach((assignment) => {
                    if (!groupedAssignments[assignment.clientContactId]) {
                        groupedAssignments[assignment.clientContactId] = [];
                    }
                    groupedAssignments[assignment.clientContactId].push(assignment);
                });
                return Object.keys(groupedAssignments).map((clientContactId) => {
                    const matchedContact = clientContacts.find((contact) => contact.id === clientContactId);
                    if (matchedContact) {
                        const reviews = groupedAssignments[clientContactId].map((assignment) => {
                            const matchedEmployee = employees.find((employee) => employee.employeeId === assignment.employeeId);
                            if (matchedEmployee) {
                                return {
                                    reviewId: assignment.reviewId,
                                    employeeId: matchedEmployee.employeeId,
                                    employeeName: matchedEmployee.employeeName,
                                };
                            }
                            return null;
                        });
                        return {
                            clientContactId: matchedContact.id,
                            clientContactName: matchedContact.name,
                            templateContent: "",
                            revieews: reviews,
                            isDeFaultTemplateChanged: false,
                        };
                    }
                    return null;
                });
            }
            return [
                {
                    clientContactId: "",
                    clientContactName: "",
                    templateContent: "",
                    revieews: [],
                    isDeFaultTemplateChanged: false,
                },
            ];
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], ClientEmailTemplate.prototype, "assignments", void 0);
    ClientEmailTemplate = __decorate([
        Component({
            name: "ClientEmailTemplate",
            components: {
                Loader,
                ClientEmailBodyTemplate,
                SectionLoader,
            },
        })
    ], ClientEmailTemplate);
    return ClientEmailTemplate;
})();
export default ClientEmailTemplate;
